import { useFeatureFlag } from './context';
/**
 * Component that conditionally renders children based on a feature flag
 *
 * @example
 * <FeatureGate flag="enableNewDashboard">
 *   <NewDashboard />
 * </FeatureGate>
 *
 * @example
 * <FeatureGate flag="enableNewDashboard" fallback={<OldDashboard />}>
 *   <NewDashboard />
 * </FeatureGate>
 */
export function FeatureGate({ flag, children, fallback = null }) {
    const isEnabled = useFeatureFlag(flag);
    return isEnabled ? children : fallback;
}
